var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29303 7.29296C5.48056 7.10549 5.73487 7.00017 6.00003 7.00017C6.26519 7.00017 6.5195 7.10549 6.70703 7.29296L10 10.586L13.293 7.29296C13.3853 7.19745 13.4956 7.12127 13.6176 7.06886C13.7396 7.01645 13.8709 6.98886 14.0036 6.98771C14.1364 6.98655 14.2681 7.01186 14.391 7.06214C14.5139 7.11242 14.6255 7.18667 14.7194 7.28056C14.8133 7.37446 14.8876 7.48611 14.9379 7.60901C14.9881 7.7319 15.0134 7.86358 15.0123 7.99636C15.0111 8.12914 14.9835 8.26036 14.9311 8.38236C14.8787 8.50437 14.8025 8.61471 14.707 8.70696L10.707 12.707C10.5195 12.8944 10.2652 12.9997 10 12.9997C9.73487 12.9997 9.48056 12.8944 9.29303 12.707L5.29303 8.70696C5.10556 8.51943 5.00024 8.26512 5.00024 7.99996C5.00024 7.73479 5.10556 7.48049 5.29303 7.29296Z",
    fill: "#9AA5B5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow);
export default __webpack_public_path__ + "static/media/dropdownArrow.86dafc297e2e832c585a5881e40d6a7b.svg";
export { ForwardRef as ReactComponent };